/**
 * Created by valentina maugeri on 31/01/2022.
 */
import {Validator_DcDc_Buck} from "./dcdc_buck_validator";
import {EntityError} from "../../../../models/EntityAlert";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic, IEntityAlert, ITranslatedObj} from "../../../../models/common";
import {
  evaluateUntilFirstValidatorOutput,
  ValidatorOutputFn,
  ValidatorSingleOutputFn
} from "../../../../models/validator/IValidator";

import {Utils} from "../../../../common/utils";

export class Validator_DcDc_IsolatedBuck extends Validator_DcDc_Buck {
  private calculate_PowerOutUpperBound(a: Ic, spec: IAppSpec): number {
    return Utils.getFieldValue(a, "validator.power.max", 5);
  }

  private validatorFn_SingleOutput_Power: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _pOut = spec.spec.value.output.outputs[o].power;
    const powerOutUpperBound: number = this.calculate_PowerOutUpperBound(ic, spec);

    const result = Utils.acceptUpTo(_pOut, powerOutUpperBound, "PLoad", "W");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Voltage_IsolatedBuck: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;
    const _vOut = spec.spec.value.output.outputs[o].voltage;

    if (Utils.isValueEmpty(_vOut)) {
      result = {
        key: "vout is required"
      };
    }

    return new EntityError(result);
  }

  protected get singleOutput(): ValidatorSingleOutputFn {
    return (a: Ic, s: IAppSpec, o: number) => {
      if (o > 0) {
        return {
          voltage: evaluateUntilFirstValidatorOutput([this.validatorFn_SingleOutput_Voltage_IsolatedBuck])(a, s, o),
          current: evaluateUntilFirstValidatorOutput(this.singleOutputI())(a, s, o),
          power: evaluateUntilFirstValidatorOutput([this.validatorFn_SingleOutput_Power])(a, s, o),
        };
      }
      return super.singleOutput(a, s, o);
    };
  }
}
